import { render } from "./ContentPenghargaan.vue?vue&type=template&id=9af2da6c&scoped=true"
import script from "./ContentPenghargaan.vue?vue&type=script&lang=js"
export * from "./ContentPenghargaan.vue?vue&type=script&lang=js"

import "./ContentPenghargaan.vue?vue&type=style&index=0&id=9af2da6c&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af2da6c"]])

export default __exports__